export default "__VITE_ASSET__BpzYFhMO__"